import script from "./CertificateApprovalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificateApprovalView.vue?vue&type=script&setup=true&lang=ts"

import "./CertificateApprovalView.vue?vue&type=style&index=0&id=bd1dc918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd1dc918"]])

export default __exports__